import React from 'react';

import useTranslation from '../../../hooks/useTranslation';

export default () => {
    const translated = useTranslation();
    return <p className="transaction-details__info_msg">{translated.transactionDetails.infoWillCome}</p>;
};
